var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { Component } from 'react';
import { observer } from "mobx-react";
import { Alert, Avatar, Button, List, Select, Switch, Checkbox } from 'antd';
import { DownOutlined, UserOutlined, PlusOutlined, WarningOutlined } from '@ant-design/icons';
import { Trans, withTranslation } from "react-i18next";
import { t } from 'i18next';
import { withRouter } from 'react-router-dom';
import { MessagingChannelFeature, ChatAccessType } from '@whatsper/texterchat-common';
import Icon from '@ant-design/icons';
import moment from 'moment';
import { omit, throttle, isEqual, isMatch, uniqBy } from 'lodash';
import { ReactComponent as QuickRepliesCross } from '../../../../../../assets/messageStatuses/closeCross.svg';
import { LABELS_COLORS } from "../../../../../../constants";
import { withStore } from '../../../../../../store/rootStore';
import ChannelSelect from '../../../../../Chat/ChatsList/ChannelSelect';
import ColorSelector from '../../../../../ColorSelector';
import { MySelect, MyInput } from '../../../../../Base/Form';
import { hasAnyError, validateAgentForm, validateField } from './validation';
import "./AgentForm.scss";
const { Option } = Select;
class AgentForm extends Component {
    constructor(props) {
        var _a;
        super(props);
        Object.defineProperty(this, "state", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                openAdvanced: true,
                displayName: '',
                email: '',
                password: '',
                confirmPassword: '',
                crmId: '',
                contacts: [],
                departments: [],
                disableInput: false,
                contactsSearchQuery: '',
                contactsTitles: {},
                color: '',
                disabled: false,
                temporary: null,
                roles: [],
                contactsChannelAccount: null,
                chatsAccess: [],
                chatAccessTitles: {},
                chatAccessChannel: null,
                chatAccessQuery: '',
                chatAccessSelection: null,
                chatAccessTypes: [],
                chatAccessSearchResults: [],
                chatAccessSearchLoading: false,
                chatAccessSamePersonChats: false,
                chatAccessRedundantRuleWarning: '',
                touched: { displayName: false, email: false, roles: false, confirmPassword: false },
                errors: {},
                submitAttempted: false,
                passwordFocused: false,
                confirmPasswordFocused: false,
            }
        });
        Object.defineProperty(this, "setInitialDepartments", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                if (this.props.entity) {
                    const departments = [], { uid } = this.props.entity;
                    this.props.store.departmentsStore.departments.map(({ agents, _id }) => {
                        if (agents && agents.includes(uid)) {
                            departments.push(_id);
                        }
                    });
                    this.onInput({ departments });
                }
            }
        });
        Object.defineProperty(this, "setInputsDisabled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                var _a;
                if ((_a = this.props.entity) === null || _a === void 0 ? void 0 : _a._id) {
                    this.setState({ disableInput: true });
                }
            }
        });
        Object.defineProperty(this, "supportsContactGlobalId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { contactsChannelAccount } = this.state;
                if (!contactsChannelAccount) {
                    return false;
                }
                const adapter = this.props.store.channels.getAccountAdapter(contactsChannelAccount);
                return !!(adapter === null || adapter === void 0 ? void 0 : adapter.features.includes(MessagingChannelFeature.contactGlobalId));
            }
        });
        Object.defineProperty(this, "onSearchContacts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (query) => {
                const { contactsChannelAccount } = this.state;
                this.setState({ contactsSearchQuery: query });
                if (contactsChannelAccount && query && query.length >= 2) {
                    this.props.store.agentsStore.searchUsersThrottled(query, contactsChannelAccount.name, 
                    // If global ID not supported then search for one channel account,
                    // if supported - for all accounts of channel
                    !this.supportsContactGlobalId()
                        ? contactsChannelAccount.id
                        : undefined);
                }
            }
        });
        Object.defineProperty(this, "onSelectContact", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                var _a;
                this.setState({ contactsSearchQuery: value });
                if (!value)
                    return;
                const { usersSearchResults } = this.props.store.agentsStore;
                const contact = (_a = usersSearchResults.find((user) => user.channelInfo.id === value)) === null || _a === void 0 ? void 0 : _a.channelInfo;
                if (!contact) {
                    return this.onNewContact(value);
                }
                this.onContactsChange(uniqBy([...this.state.contacts, contact], 'id'));
            }
        });
        Object.defineProperty(this, "onNewContact", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                const { contactsChannelAccount } = this.state;
                if (contactsChannelAccount && value) {
                    const contact = {
                        accountId: contactsChannelAccount.id,
                        name: contactsChannelAccount.name,
                        id: value.trim(),
                    };
                    this.onContactsChange(uniqBy([...this.state.contacts, contact], 'id'));
                }
            }
        });
        Object.defineProperty(this, "onRemoveContact", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id) => {
                const contacts = this.state.contacts.filter(c => c.id !== id);
                this.onContactsChange(contacts);
            }
        });
        Object.defineProperty(this, "fetchChatAccessTitles", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (accesses) => {
                const { chatAccessTitles } = this.state;
                if (!accesses || accesses.length === 0)
                    return;
                accesses.forEach((access) => {
                    const { id } = access; // otherwise as property TS don't follow type narrowing
                    if (!id || chatAccessTitles[id])
                        return;
                    this.props.store.chatsStore.fetchChatByChannelId(access) // idk why error here - we ensure that id not undefined right above
                        .then((chat) => {
                        if (chat) {
                            this.setState((state) => ({
                                chatAccessTitles: Object.assign(Object.assign({}, state.chatAccessTitles), { [id]: chat.title }),
                            }));
                        }
                    });
                });
            }
        });
        Object.defineProperty(this, "fetchContactTitles", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (contacts) => {
                const { contactsTitles } = this.state;
                if (!contacts || contacts.length === 0)
                    return;
                contacts.forEach((contact) => {
                    if (contactsTitles[contact.id])
                        return;
                    this.props.store.chatsStore.fetchChatByChannelId(contact)
                        .then((chat) => {
                        if (chat) {
                            this.setState((state) => {
                                return {
                                    contactsTitles: Object.assign(Object.assign({}, state.contactsTitles), { [contact.id]: chat.title }),
                                };
                            });
                        }
                        else {
                            console.debug('No existing chat for: ', contact);
                        }
                    })
                        .catch(console.error);
                });
            }
        });
        Object.defineProperty(this, "dropdownMenu", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return React.createElement(React.Fragment, null,
                    this.props.store.departmentsStore.departments.map((department, i) => (React.createElement(Option, { key: i, icon: React.createElement(UserOutlined, null), value: department._id },
                        React.createElement("div", { style: { backgroundColor: department.color ? department.color : "lightgrey" }, className: "select-department-color" }),
                        department.name))),
                    React.createElement(Option, { className: "manage-departments-option", disabled: true, value: "" },
                        React.createElement(Button, { className: "manage-departments-button", onClick: () => this.openDepartmentsManager() },
                            React.createElement(Trans, { i18nKey: "manageDepartments" }))));
            }
        });
        Object.defineProperty(this, "renderContactOptions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { t, store } = this.props;
                const { usersSearchResults } = store.agentsStore;
                const { contactsSearchQuery } = this.state;
                const globalId = this.supportsContactGlobalId();
                const results = usersSearchResults.map(({ channelInfo, title }) => ({
                    value: channelInfo.id,
                    label: globalId ? `${title} (${channelInfo.id})` : title,
                }));
                /* enter custom input mode */
                if (usersSearchResults.length === 0 && globalId && contactsSearchQuery) {
                    results.unshift({
                        label: `${contactsSearchQuery} (+${t('createNew')})`,
                        value: `${contactsSearchQuery} `, // trick to trigger onChange
                    });
                }
                return uniqBy(results, 'value');
            }
        });
        Object.defineProperty(this, "openDepartmentsManager", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.props.history.push('/manage/departments', { prevPath: this.props.location.pathname });
            }
        });
        Object.defineProperty(this, "handleChatAccessSearch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: throttle((query) => __awaiter(this, void 0, void 0, function* () {
                const { chatAccessChannel } = this.state;
                if (!query || !chatAccessChannel) {
                    this.setState({ chatAccessSearchResults: [], chatAccessSearchLoading: false });
                    return;
                }
                this.setState({ chatAccessSearchLoading: true });
                try {
                    const params = {
                        search: query,
                        channelAccountId: chatAccessChannel.id,
                        channelName: chatAccessChannel.name,
                    };
                    const result = yield this.props.store.chatsStore.fetchChats(params);
                    if (result) {
                        this.setState({ chatAccessSearchResults: result.chats });
                    }
                }
                catch (error) {
                    console.error("Failed to search chats", error);
                    this.setState({ chatAccessSearchResults: [] });
                }
                finally {
                    this.setState({ chatAccessSearchLoading: false });
                }
            }), 500)
        });
        Object.defineProperty(this, "onChatAccessChannelChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (channel) => {
                this.setState({
                    chatAccessChannel: channel,
                    chatAccessSelection: null,
                    chatAccessSearchResults: [],
                    chatAccessTypes: channel ? [ChatAccessType.list] : [],
                });
            }
        });
        Object.defineProperty(this, "onChatAccessSelect", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (selection) => {
                if (!selection) {
                    this.setState({ chatAccessSelection: null });
                    return;
                }
                const selectedChat = this.state.chatAccessSearchResults.find(c => c.channelInfo.id === selection);
                if (selectedChat) {
                    this.setState(prevState => ({
                        chatAccessSelection: selection,
                        chatAccessTitles: Object.assign(Object.assign({}, prevState.chatAccessTitles), { [selection]: selectedChat.title })
                    }), this.validateRedundantChatAccess);
                }
                else {
                    this.setState({ chatAccessSelection: selection }, this.validateRedundantChatAccess);
                }
            }
        });
        Object.defineProperty(this, "onAddChatAccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { chatAccessChannel, chatAccessSelection, chatAccessTypes, chatsAccess, chatAccessSamePersonChats } = this.state;
                if (!chatAccessChannel || chatAccessTypes.length === 0) {
                    return;
                }
                const newAccess = {
                    accountId: chatAccessChannel.id,
                    name: chatAccessChannel.name,
                    id: chatAccessSelection !== null && chatAccessSelection !== void 0 ? chatAccessSelection : undefined,
                    type: chatAccessTypes,
                    samePersonChats: chatAccessSamePersonChats,
                };
                const alreadyExists = chatsAccess.some(p => p.accountId === newAccess.accountId && p.id === newAccess.id);
                if (alreadyExists) {
                    console.warn('This chat access rule already exists.');
                    return;
                }
                this.onInput({
                    chatsAccess: [...chatsAccess, newAccess]
                });
                this.setState({
                    chatAccessChannel: null,
                    chatAccessSelection: null,
                    chatAccessTypes: [],
                    chatAccessSearchResults: [],
                    chatAccessSamePersonChats: false,
                });
            }
        });
        Object.defineProperty(this, "validateRedundantChatAccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { t } = this.props;
                const { chatAccessChannel, chatAccessSelection, chatsAccess } = this.state;
                if (chatAccessChannel && chatAccessSelection) {
                    const hasFullChannelAccess = chatsAccess.some(p => p.accountId === chatAccessChannel.id && !p.id);
                    if (hasFullChannelAccess) {
                        this.setState({ chatAccessRedundantRuleWarning: t('chatAccessRedundantRuleWarning') });
                        return;
                    }
                }
                this.setState({ chatAccessRedundantRuleWarning: '' });
            }
        });
        Object.defineProperty(this, "onRemoveChatAccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (accountId, id) => {
                this.onInput({
                    chatsAccess: this.state.chatsAccess.filter(p => !(p.accountId === accountId && p.id === id))
                });
            }
        });
        Object.defineProperty(this, "onPasswordFieldFocus", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (e, focusedKey) => {
                e.target.removeAttribute('readOnly');
                if (!this.state[focusedKey]) {
                    this.setState({ [focusedKey]: true });
                }
            }
        });
        Object.defineProperty(this, "onTextInputChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value, name) => {
                let patch = this.withRevalidation({ [name]: value }, name);
                if (name === 'password') {
                    patch = this.withCrossFieldRevalidation(patch, 'confirmPassword');
                }
                this.onInput(patch);
            }
        });
        Object.defineProperty(this, "onContactsChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (contacts) => {
                this.onInput({
                    contacts,
                });
            }
        });
        Object.defineProperty(this, "onSelectInputChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value, name) => {
                this.onInput(this.withRevalidation({ [name]: value }, name));
            }
        });
        Object.defineProperty(this, "onFieldBlur", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (field) => {
                const nextValues = this.getValidationValues();
                const error = validateField(field, nextValues);
                this.onInput({
                    touched: Object.assign(Object.assign({}, this.state.touched), { [field]: true }),
                    errors: Object.assign(Object.assign({}, this.state.errors), { [field]: error }),
                });
            }
        });
        Object.defineProperty(this, "validate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const errors = validateAgentForm(this.getValidationValues());
                this.onInput({
                    errors,
                    touched: { displayName: true, email: true, roles: true, confirmPassword: true },
                    submitAttempted: true,
                });
                return !hasAnyError(errors);
            }
        });
        Object.defineProperty(this, "getValidationValues", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => ({
                displayName: this.state.displayName,
                email: this.state.email,
                roles: this.state.roles,
                password: this.state.password,
                confirmPassword: this.state.confirmPassword,
            })
        });
        Object.defineProperty(this, "isValidatableField", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (name) => name === 'displayName' || name === 'email' || name === 'roles' || name === 'confirmPassword'
        });
        Object.defineProperty(this, "withRevalidation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (patch, name) => {
                var _a;
                if (!this.isValidatableField(name))
                    return patch;
                const shouldRevalidate = this.state.touched[name] || this.state.submitAttempted;
                if (!shouldRevalidate)
                    return patch;
                const nextValues = Object.assign(Object.assign({}, this.getValidationValues()), patch);
                const error = validateField(name, nextValues);
                return Object.assign(Object.assign({}, patch), { errors: Object.assign(Object.assign({}, ((_a = patch.errors) !== null && _a !== void 0 ? _a : this.state.errors)), { [name]: error }) });
            }
        });
        Object.defineProperty(this, "withCrossFieldRevalidation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (patch, dependentField) => {
                var _a;
                const shouldRevalidate = this.state.touched[dependentField] || this.state.submitAttempted;
                if (!shouldRevalidate)
                    return patch;
                const nextValues = Object.assign(Object.assign({}, this.getValidationValues()), patch);
                const error = validateField(dependentField, nextValues);
                return Object.assign(Object.assign({}, patch), { errors: Object.assign(Object.assign({}, ((_a = patch.errors) !== null && _a !== void 0 ? _a : this.state.errors)), { [dependentField]: error }) });
            }
        });
        Object.defineProperty(this, "onInput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (formData) => {
                this.setState(Object.assign({}, formData), () => this.props.onInput(omit(this.state, [
                    'openAdvanced',
                    'disableInput',
                    'contactsSearchQuery',
                    'contactsChannelAccount',
                    'contactsTitles',
                    'chatAccessTitles',
                    'chatAccessChannel',
                    'chatAccessQuery',
                    'chatAccessSelection',
                    'chatAccessTypes',
                    'chatAccessSearchResults',
                    'chatAccessSearchLoading',
                    'chatAccessSamePersonChats',
                    'chatAccessRedundantRuleWarning',
                    'touched',
                    'errors',
                    'submitAttempted',
                    'confirmPassword',
                ]), this.canBeSavedState()));
            }
        });
        Object.defineProperty(this, "validateCrmId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => __awaiter(this, void 0, void 0, function* () {
                var _a;
                const crmId = this.state.crmId;
                if (!crmId) {
                    const isValid = !(yield this.props.store.agentsStore.isAnyUserHaveCrmId());
                    this.setState({ crmIdValidationError: isValid ? '' : t('crmIdEmpty') });
                }
                else {
                    const user = yield this.props.store.agentsStore.getAgentByCrmId(crmId);
                    const isValid = !user || user._id === ((_a = this.props.entity) === null || _a === void 0 ? void 0 : _a._id);
                    this.setState({ crmIdValidationError: isValid ? '' : t('crmIdTaken') });
                }
            })
        });
        Object.defineProperty(this, "isChatAccessRequiredButMissing", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                var _a;
                return ((_a = this.state.roles) === null || _a === void 0 ? void 0 : _a[0]) === 'agent_no_chats' && this.state.chatsAccess.length === 0;
            }
        });
        Object.defineProperty(this, "canBeSavedState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                var _a;
                if (!!((_a = this.props.entity) === null || _a === void 0 ? void 0 : _a.disabled) && this.state.disabled)
                    return false;
                if (this.isChatAccessRequiredButMissing())
                    return false;
                return !hasAnyError(this.state.errors);
            }
        });
        if (props.store.channels.defaultAccount) {
            this.state = Object.assign(Object.assign({}, this.state), { contactsChannelAccount: {
                    id: props.store.channels.defaultAccount.accountId,
                    name: props.store.channels.defaultAccount.channel,
                } });
        }
        if (props.entity) {
            const chatsAccess = (props.entity.chatsAccess || [])
                .filter((access) => {
                return props.store.channels.accounts.some((a) => {
                    return a.accountId === access.accountId && a.channel === access.name;
                });
            });
            this.state = Object.assign(Object.assign(Object.assign({}, this.state), props.entity), { contacts: (_a = props.entity.contacts) !== null && _a !== void 0 ? _a : [], chatsAccess, openAdvanced: false, touched: { displayName: true, email: true, roles: true, confirmPassword: true } });
        }
        this.validateCrmId();
    }
    componentDidMount() {
        var _a, _b;
        const { entity } = this.props;
        this.setInitialDepartments();
        this.setInputsDisabled();
        (_b = (_a = this.props).onRegisterValidate) === null || _b === void 0 ? void 0 : _b.call(_a, this.validate);
        if (entity) {
            if (typeof entity.displayName === 'string') {
                this.onSearchContacts(entity.displayName);
            }
            this.fetchContactTitles(entity.contacts);
            this.fetchChatAccessTitles(this.state.chatsAccess);
        }
    }
    componentWillUnmount() {
        var _a, _b;
        (_b = (_a = this.props).onRegisterValidate) === null || _b === void 0 ? void 0 : _b.call(_a, null);
    }
    componentDidUpdate(prevProps, prevState) {
        var _a, _b, _c;
        if (!isEqual((_a = prevProps.entity) === null || _a === void 0 ? void 0 : _a.chatsAccess, (_b = this.props.entity) === null || _b === void 0 ? void 0 : _b.chatsAccess)) {
            const existingChatsAccess = (((_c = this.props.entity) === null || _c === void 0 ? void 0 : _c.chatsAccess) || [])
                .filter((access) => {
                return this.props.store.channels.accounts.some((a) => {
                    return a.accountId === access.accountId && a.channel === access.name;
                });
            });
            this.setState({ chatsAccess: existingChatsAccess });
        }
        if (!isMatch(this.state.contactsChannelAccount || {}, prevState.contactsChannelAccount || {})) {
            this.props.store.agentsStore.clearSearchUsers();
        }
        if (this.state.contacts.length !== prevState.contacts.length) {
            this.fetchContactTitles(this.state.contacts);
        }
        if (this.state.chatsAccess.length !== prevState.chatsAccess.length) {
            this.fetchChatAccessTitles(this.state.chatsAccess);
        }
        if (!isMatch(this.state.chatAccessChannel || {}, prevState.chatAccessChannel || {})) {
            this.props.store.chatsStore.setChannel(this.state.chatAccessChannel, true);
        }
        if (this.state.crmId !== prevState.crmId) {
            this.validateCrmId();
        }
        if (this.state.chatAccessSelection !== prevState.chatAccessSelection || this.state.chatAccessChannel !== prevState.chatAccessChannel) {
            this.validateRedundantChatAccess();
        }
    }
    render() {
        const { openAdvanced, displayName, email, crmId, confirmPassword, departments, roles, disableInput, contactsSearchQuery, contactsChannelAccount, contacts, contactsTitles, color, disabled, temporary, chatsAccess, chatAccessChannel, chatAccessTitles, chatAccessTypes, chatAccessSearchResults, chatAccessSearchLoading, chatAccessSamePersonChats, crmIdValidationError, chatAccessRedundantRuleWarning, touched, errors, } = this.state, { t, error, store } = this.props;
        return (React.createElement(React.Fragment, null,
            !!error &&
                React.createElement("div", { className: "add-agent-error" }, error),
            temporary && (React.createElement("div", { className: "add-agent-labeled-input" },
                React.createElement(Alert, { message: React.createElement(Trans, { i18nKey: "userTemporary" }), description: React.createElement("span", { className: "temporary-user-container" },
                        React.createElement(Trans, { i18nKey: "expirationDate" }),
                        React.createElement("span", { className: "temporary-user-date" }, moment(temporary.till).format('LLL'))), type: "info", showIcon: true }))),
            React.createElement("div", { className: "add-agent-labeled-input" },
                React.createElement("label", null,
                    React.createElement(Trans, { i18nKey: "name" })),
                React.createElement(MyInput, { value: displayName, onChangeHandler: (value) => this.onTextInputChange(value, 'displayName'), onBlur: () => this.onFieldBlur('displayName'), placeholder: t('enterName'), error: touched.displayName && errors.displayName ? t(errors.displayName) : undefined })),
            React.createElement("div", { className: "add-agent-labeled-input" },
                React.createElement("label", null,
                    React.createElement(Trans, { i18nKey: "agentColor" })),
                React.createElement(ColorSelector, { onChange: (color) => this.onInput({ color }), color: color, colors: LABELS_COLORS, showNoColor: true })),
            React.createElement("div", { className: "add-agent-labeled-input" },
                React.createElement("label", null,
                    React.createElement(Trans, { i18nKey: "email" })),
                React.createElement(MyInput, { disabled: disableInput, placeholder: t('enterEmail'), onChangeHandler: (value) => this.onTextInputChange(value, 'email'), onBlur: () => this.onFieldBlur('email'), value: email, error: touched.email && errors.email ? t(errors.email) : undefined })),
            React.createElement("div", { className: "add-agent-labeled-input add-agent-labeled-input-contacts" },
                React.createElement("label", null,
                    React.createElement(Trans, { i18nKey: "contacts" }),
                    " (",
                    contacts.length,
                    ")"),
                React.createElement("div", { className: "show-contacts-container" }, (contacts === null || contacts === void 0 ? void 0 : contacts.length) > 0 && (React.createElement(List, { dataSource: contacts, itemLayout: "horizontal", size: "small", bordered: true, renderItem: ({ id, name }) => {
                        var _a;
                        return (React.createElement(List.Item, { actions: [
                                React.createElement("div", { onClick: () => this.onRemoveContact(id) },
                                    React.createElement("div", { className: "remove-cross" },
                                        React.createElement(Icon, { component: QuickRepliesCross })))
                            ] },
                            React.createElement(List.Item.Meta, { avatar: React.createElement(Avatar, { src: (_a = store.channels.themes[name]) === null || _a === void 0 ? void 0 : _a.icon }), title: contactsTitles[id]
                                    ? `${contactsTitles[id]} (${id})`
                                    : id })));
                    } }))),
                React.createElement("div", { className: "add-contacts-container" },
                    React.createElement("label", null,
                        React.createElement(Trans, { i18nKey: "addContact" }),
                        ":"),
                    React.createElement(ChannelSelect, { accounts: store.channels.accounts, activeChannel: contactsChannelAccount, onChannelClick: (contactsChannelAccount) => this.setState({ contactsChannelAccount }), showAll: false, className: "channel-select" }),
                    React.createElement(MySelect, { value: contactsSearchQuery, onSearch: this.onSearchContacts, onChange: this.onSelectContact, placeholder: t("searchPlaceholder"), defaultActiveFirstOption: true, filterOption: false, options: this.renderContactOptions(), showArrow: false, showSearch: true, allowClear: true }))),
            React.createElement("div", { className: "add-agent-labeled-input" },
                React.createElement("label", null,
                    React.createElement(Trans, { i18nKey: "password" })),
                React.createElement(MyInput.Password, { placeholder: t('enterPassword'), onChangeHandler: (value) => this.onTextInputChange(value, 'password'), name: "agent_password_update", autoComplete: "new-password", readOnly: true, onFocus: (e) => this.onPasswordFieldFocus(e, 'passwordFocused'), iconRender: this.state.passwordFocused ? undefined : null })),
            React.createElement("div", { className: "add-agent-labeled-input" },
                React.createElement("label", null,
                    React.createElement(Trans, { i18nKey: "confirmPassword" })),
                React.createElement(MyInput.Password, { placeholder: t('confirmPassword'), value: confirmPassword, onChangeHandler: (value) => this.onTextInputChange(value, 'confirmPassword'), onBlur: () => this.onFieldBlur('confirmPassword'), name: "agent_password_confirm", autoComplete: "new-password", readOnly: true, onFocus: (e) => this.onPasswordFieldFocus(e, 'confirmPasswordFocused'), iconRender: this.state.confirmPasswordFocused ? undefined : null, error: touched.confirmPassword && errors.confirmPassword ? t(errors.confirmPassword) : undefined })),
            React.createElement("div", { className: "add-agent-labeled-input" },
                React.createElement("label", null,
                    React.createElement(Trans, { i18nKey: "chooseRoles" })),
                React.createElement(MySelect
                // roles is an array but we are only allowing one role per agent, hence the [0]
                , { 
                    // roles is an array but we are only allowing one role per agent, hence the [0]
                    value: roles === null || roles === void 0 ? void 0 : roles[0], onChange: (value) => {
                        this.onSelectInputChange([value], 'roles');
                    }, onBlur: () => this.onFieldBlur('roles'), status: touched.roles && errors.roles ? 'error' : undefined, options: store.agentsStore.roles.map((role) => {
                        var _a;
                        return ({
                            value: role.name,
                            label: t(`role_${role.name}`, (_a = role.title) !== null && _a !== void 0 ? _a : role.name)
                        });
                    }) }),
                touched.roles && errors.roles && (React.createElement("div", { className: "add-agent-labeled-input-error" },
                    React.createElement(WarningOutlined, null),
                    t(errors.roles)))),
            React.createElement("div", { className: "add-agent-labeled-input full-height" },
                React.createElement("label", null,
                    React.createElement(Trans, { i18nKey: "chooseDepartment" })),
                React.createElement(MySelect, { value: departments, dropdownStyle: { padding: 0 }, className: "add-agent-dropdown", mode: "multiple", allowClear: true, onChange: (departments) => this.onInput({ departments }) }, this.dropdownMenu())),
            React.createElement("fieldset", { className: "agent-form-fieldset" },
                React.createElement("legend", null,
                    React.createElement(Trans, { i18nKey: "chatAccess" }),
                    " ",
                    chatsAccess.length > 0 && `(${chatsAccess.length})`),
                React.createElement("p", { className: "fieldset-description" },
                    React.createElement(Trans, { i18nKey: "chatAccessDescription" })),
                this.isChatAccessRequiredButMissing() && (React.createElement(Alert, { message: React.createElement(Trans, { i18nKey: "chatAccessRequiredForNoChatsRole" }), type: "warning", showIcon: true, style: { marginTop: 8 } })),
                React.createElement("div", { className: "show-contacts-container" }, (chatsAccess === null || chatsAccess === void 0 ? void 0 : chatsAccess.length) > 0 && (React.createElement(List, { dataSource: chatsAccess, itemLayout: "horizontal", size: "small", bordered: true, renderItem: ({ id, name, type, accountId, samePersonChats }) => {
                        var _a, _b;
                        const account = store.channels.accounts.find(acc => acc.accountId === accountId);
                        const channelTitle = (account === null || account === void 0 ? void 0 : account.title) || ((_a = account === null || account === void 0 ? void 0 : account.metadata) === null || _a === void 0 ? void 0 : _a.accountTitle) || accountId;
                        const prettyChannelName = t(`${name}Channel`, { defaultValue: name });
                        return (React.createElement(List.Item, { actions: [
                                React.createElement("div", { onClick: () => this.onRemoveChatAccess(accountId, id) },
                                    React.createElement("div", { className: "remove-cross" },
                                        React.createElement(Icon, { component: QuickRepliesCross })))
                            ] },
                            React.createElement(List.Item.Meta, { avatar: React.createElement(Avatar, { src: (_b = store.channels.themes[name]) === null || _b === void 0 ? void 0 : _b.icon }), title: !id
                                    ? t('allChatsInChannel', { channel: `${prettyChannelName} (${channelTitle})`, defaultValue: `All chats in ${prettyChannelName} (${channelTitle})` })
                                    : chatAccessTitles[id]
                                        ? `${chatAccessTitles[id]} (${id})`
                                        : id, description: React.createElement(React.Fragment, null,
                                    React.createElement("div", null, type.join(', ')),
                                    samePersonChats && React.createElement("div", null,
                                        React.createElement(Trans, { i18nKey: "chatAccessSamePersonChats" }))) })));
                    } }))),
                React.createElement("div", { className: "add-contacts-container", style: { marginTop: '10px' } },
                    React.createElement("label", null,
                        React.createElement(Trans, { i18nKey: "addAccess" }),
                        ":"),
                    React.createElement(ChannelSelect, { accounts: store.channels.accounts, activeChannel: chatAccessChannel, onChannelClick: this.onChatAccessChannelChange, showAll: false, className: "channel-select" }),
                    React.createElement(MySelect, { value: this.state.chatAccessSelection, onSearch: this.handleChatAccessSearch, onChange: this.onChatAccessSelect, placeholder: t("searchChatPlaceholder"), filterOption: false, options: chatAccessSearchResults.map((chat) => ({
                            value: chat.channelInfo.id,
                            label: `${chat.title} (${chat.channelInfo.id})`,
                        })), showArrow: false, showSearch: true, allowClear: true, disabled: !chatAccessChannel, loading: chatAccessSearchLoading, notFoundContent: chatAccessSearchLoading ? null : undefined }),
                    React.createElement(MySelect, { mode: "multiple", allowClear: true, value: chatAccessTypes, onChange: (chatAccessTypes) => this.setState({ chatAccessTypes }), placeholder: t("selectAccessType"), options: Object.values(ChatAccessType).map((t) => ({ label: t, value: t })), disabled: !chatAccessChannel, style: { minWidth: '120px' } }),
                    React.createElement(Checkbox, { checked: chatAccessSamePersonChats, onChange: e => this.setState({ chatAccessSamePersonChats: e.target.checked }), disabled: !chatAccessChannel, className: "same-person-chat-checkbox" },
                        React.createElement(Trans, { i18nKey: "chatAccessSamePersonChats" })),
                    chatAccessChannel && !this.state.chatAccessSelection && (React.createElement(Alert, { message: React.createElement(Trans, { i18nKey: "allChatsInChannelGrantInfo" }), type: "info", showIcon: true, style: { marginTop: 8 } })),
                    chatAccessRedundantRuleWarning && (React.createElement(Alert, { message: chatAccessRedundantRuleWarning, type: "warning", showIcon: true, style: { marginTop: 8 } })),
                    React.createElement(Button, { type: "primary", onClick: this.onAddChatAccess, disabled: !chatAccessChannel || chatAccessTypes.length === 0, className: "add-chat-access-button" },
                        React.createElement(PlusOutlined, null)))),
            React.createElement("div", { "data-readonly-exempt": true, className: "add-agent-labeled-input" },
                React.createElement("label", null,
                    React.createElement(Trans, { i18nKey: "disabled" })),
                React.createElement(Switch, { checked: disabled, onChange: (disabled) => this.onInput({ disabled }), className: "disabled-switch" })),
            React.createElement("div", { className: "add-agent-advanced-handle", onClick: () => this.setState(({ openAdvanced }) => ({ openAdvanced: !openAdvanced })) },
                React.createElement(Trans, { i18nKey: "Advanced" }),
                React.createElement(DownOutlined, { className: "add-agent-advanced-handle-arrow" })),
            openAdvanced && React.createElement("div", { className: "add-agent-labeled-input" },
                React.createElement("label", null,
                    React.createElement(Trans, { i18nKey: "crmId" })),
                React.createElement(MyInput, { value: crmId, onChangeHandler: (value) => this.onTextInputChange(value, 'crmId'), placeholder: t('crmId') })),
            crmIdValidationError && openAdvanced && React.createElement("div", { className: "add-agent-labeled-input" },
                React.createElement("div", { className: "add-agent-labeled-input-error" },
                    React.createElement(WarningOutlined, null),
                    crmIdValidationError))));
    }
}
export default withTranslation()(withRouter(
// @ts-expect-error // This types error really hard to understand. TODO: Fix when will be more time
withStore(observer(AgentForm))));
